import {
  cashOutline,
  flagOutline,
  gridOutline,
  helpCircleOutline,
  logOutOutline,
  personCircleOutline,
  sparklesOutline,
} from "ionicons/icons";

export const enum MARKETING_PAGE_SECTIONS {
  IntroSection = "mfp-marketing-IntroSection",
  EverythingYouNeed = "mfp-marketing-EverythingYouNeed",
  WhyMyFirePlane = "mfp-marketing-WhyMyFirePlane",
  Pricing = "mfp-marketing-Pricing",
  Testimonies = "mfp-marketing-Testimonies",
  PremiumFeatures = "mfp-marketing-PremiumFeatures",
}

export const LOGIN_MENU_ITEM = {
    icon: personCircleOutline,
    label: "Login",
    linkTo: "/login",
  },
  LOGOUT_MENU_ITEM = {
    icon: logOutOutline,
    label: "Logout",
    linkTo: "/home",
  },
  DASHBOARD_MENU_ITEM = {
    icon: gridOutline,
    label: "Dashboard",
    linkTo: "/dashboard",
  },
  GET_STARTED_MENU_ITEM = {
    icon: flagOutline,
    label: "Get Started",
    linkTo: "/register",
  },
  PREMIUM_FEATURES_MENU_ITEM = {
    icon: sparklesOutline,
    label: "Premium Features",
    linkTo: `/home#${MARKETING_PAGE_SECTIONS.PremiumFeatures}`,
  },
  FAQ_MENU_ITEM = { icon: helpCircleOutline, label: "FAQs", linkTo: "/FAQ" },
  PRICING_MENU_ITEM = {
    icon: cashOutline,
    label: "Pricing",
    linkTo: `/home#${MARKETING_PAGE_SECTIONS.Pricing}`,
  },
  CONTACT_US_MENU_ITEM = {
    icon: null,
    label: "Contact Us",
    linkTo: "mailto:support@myfireplane.com",
  },
  TERMS_OF_USE_MENU_ITEM = {
    icon: null,
    label: "Terms of Use",
    linkTo: `/terms-of-use`,
  },
  PRIVACY_POLICY_MENU_ITEM = {
    icon: null,
    label: "Privacy Policy",
    linkTo: `/privacy-policy`,
  },
  EVERYTHING_YOU_NEED_MENU_ITEM = {
    icon: null,
    label: null,
    linkTo: `/home#${MARKETING_PAGE_SECTIONS.EverythingYouNeed}`,
  },
  MAIN_MENU_ITEMS = [
    PREMIUM_FEATURES_MENU_ITEM,
    FAQ_MENU_ITEM,
    PRICING_MENU_ITEM,
  ];
